import { coerceBooleanProperty } from "@angular/cdk/coercion";
import { Component, EventEmitter, Input, Output } from "@angular/core";

import { Status } from "@lantern/app/models";

export type ButtonTypes = "submit" | "reset" | "button";

export type ButtonPriorities = "primary" | "secondary" | "tertiary";

@Component({
  selector: "ta-button",
  templateUrl: "./button.template.html"
})
export class ButtonComponent {
  @Input()
  get disabled(): boolean {
    return this._disabled;
  }
  set disabled(val: boolean) {
    this._disabled = val != null && val !== false;
  }
  _disabled: boolean = false;

  @Input()
  disabledTooltipMessage?: string;

  @Input()
  get inline(): boolean {
    return this._inline;
  }

  set inline(val: boolean) {
    this._inline = coerceBooleanProperty(val);
    this.ensureInlineIsTertiary();
  }

  private ensureInlineIsTertiary(): void {
    if (this.inline && this.priority !== "tertiary") {
      // tslint:disable-next-line:no-console
      console.warn("inline property only compatible with tertiary buttons");
      this._priority = "tertiary";
    }
  }

  _inline = false;

  @Input()
  type: ButtonTypes = "button";

  @Input()
  get priority(): ButtonPriorities {
    return this._priority;
  }
  set priority(val: ButtonPriorities) {
    if (this._priority === val) {
      return;
    }
    this._priority = val;
    this.ensureInlineIsTertiary();
  }
  _priority: ButtonPriorities = "secondary";

  @Input()
  status: Status | "" = "";

  @Input()
  get full(): boolean {
    return this._full;
  }

  set full(value: boolean) {
    this._full = coerceBooleanProperty(value);
  }
  private _full: boolean;

  get class(): object {
    return {
      [this.status]: true,
      [this.priority]: true,
      flex: !this.inline,
      "align-items--center": !this.inline,
      "justify-content--center": !this.inline
    };
  }

  @Output()
  interact = new EventEmitter<void>();

  @Input()
  get icon(): boolean {
    return this._icon;
  }
  set icon(val: boolean) {
    this._icon = coerceBooleanProperty(val);
  }
  private _icon: boolean;
}
